var _defs, _g, _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62.7875px",
    height: "57.199999999999996px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "218.60625 46.400000000000006 62.7875 57.199999999999996",
    style: {
      background: "rgba(0, 0, 0, 0)"
    },
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "editing-hole",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#2d1b1b",
    result: "black"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    operator: "dilate",
    radius: 2,
    in: "SourceGraphic",
    result: "erode"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "erode",
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "blur",
    dx: 2,
    dy: 2,
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "atop",
    in: "offset",
    in2: "black",
    result: "merge"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "merge",
    in2: "SourceGraphic",
    result: "inner-shadow"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#editing-hole)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.47001594305038, 80.77499914169312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.31-11.46L7.87-11.46L7.87-10.25L4.78-10.25L4.78 0L3.40 0L3.40-10.25L0.31-10.25L0.31-11.46ZM10.30-4.86L14.93-4.86L14.93-5.20L14.93-5.20Q14.93-6.27 14.35-6.91L14.35-6.91L14.35-6.91Q13.77-7.55 12.75-7.55L12.75-7.55L12.75-7.55Q11.78-7.55 11.10-6.85L11.10-6.85L11.10-6.85Q10.42-6.15 10.30-4.86L10.30-4.86ZM15.73-1.70L15.73-1.70L15.73-0.44L15.73-0.44Q14.72 0.09 13.28 0.09L13.28 0.09L13.28 0.09Q11.32 0.09 10.12-1.11L10.12-1.11L10.12-1.11Q8.93-2.31 8.93-4.28L8.93-4.28L8.93-4.28Q8.93-6.34 10.00-7.53L10.00-7.53L10.00-7.53Q11.07-8.72 12.75-8.72L12.75-8.72L12.75-8.72Q14.37-8.72 15.32-7.68L15.32-7.68L15.32-7.68Q16.27-6.65 16.27-4.74L16.27-4.74L16.27-4.74Q16.27-4.20 16.18-3.74L16.18-3.74L10.30-3.74L10.30-3.74Q10.46-2.47 11.27-1.79L11.27-1.79L11.27-1.79Q12.09-1.10 13.41-1.10L13.41-1.10L13.41-1.10Q14.86-1.10 15.73-1.70ZM24.67-8.64L21.88-4.40L24.77 0L23.22 0L21.13-3.40L18.97 0L17.49 0L20.38-4.42L17.66-8.64L19.21-8.64L21.17-5.41L23.14-8.64L24.67-8.64ZM30.67-7.53L28.29-7.53L28.29-2.48L28.29-2.48Q28.29-1.10 29.58-1.10L29.58-1.10L29.58-1.10Q30.24-1.10 30.75-1.50L30.75-1.50L30.75-0.22L30.75-0.22Q30.19 0.09 29.50 0.09L29.50 0.09L29.50 0.09Q26.95 0.09 26.95-2.52L26.95-2.52L26.95-7.53L25.57-7.53L25.57-8.62L26.95-8.62L26.95-10.76L28.29-10.76L28.29-8.62L30.67-8.62L30.67-7.53Z",
    fill: "#0a0101"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "text {\n  font-size: 72px;\n  font-family: Arial Black;\n  dominant-baseline: central;\n  text-anchor: middle;\n}")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextbox);
export default __webpack_public_path__ + "static/media/textbox.284bf756801c2074232c34e88ab1dfb8.svg";
export { ForwardRef as ReactComponent };